import React from 'react';
import Image from 'next/image';
import privacypolicybaner from "@/public/images/termsimg.jpeg";

const RefundPolicy = () => {
  return (
    <>
    <div>
       <Image src={privacypolicybaner} alt='recruitment automation software' className='w-full h-[70vh]'/>
       <div className='2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 my-20 '>
          <h2 className='text-[#51a9ff] font-semibold'>EASYCAMPUS - Online Campus Placement Portal; Refund Policy </h2>
          <br/>
          <p>At EASYCAMPUS, we understand how much you value every payment; hence we are devoted to 
          making your refund experience as clean and transparent as possible. </p>
         <div className='mt-6'>
            <h4>Refunds</h4>
            <p className='my-3 text-xl leading-9'>Refunds are not possible on EASYCAMPUS’s payment gateway. Once the payment is done, it can only be tracked but cannot be refunded to its original source. </p>
            <h4>Refunds (if applicable)</h4>
            <p className='mt-5 text-xl leading-9'>Only under exigent circumstances, and at the sole discretion of Global Aspirants, refund requests can be entertained. However there is no guarantee that refunds will be processed. <br/>
            Only under vital circumstances, and at the sole discretion of EASYCAMPUS, refund requests can be entertained. However, there is no guarantee that the entertained request of refunds will be processed. <br/>
            Since each refund request requires a lot of devoted time and efforts, therefore EASYCAMPUS will internally evaluate the reasons and conditions requiring a refund and help process the request. It is highly recommended that the establishment clears the refund policy to its internal users for better service experience. 
            </p> <br/>
            <h4>In case of approval, the refund will be processed in 10-15 working days. </h4>
         </div>
       </div>
     </div>
    </>
    
  )
}

export default RefundPolicy